//IMPORTAR CARAS
import Aguero from '../assets/caras/seleccion/Aguero.jpg'
import Andrada from '../assets/caras/seleccion/Andrada.jpg'
import Armani from '../assets/caras/seleccion/Armani.jpg'
import Correa from '../assets/caras/seleccion/Correa.jpg'
import DePaul from '../assets/caras/seleccion/DePaul.jpg'
import DiMaria from '../assets/caras/seleccion/DiMaria.jpg'
import Dominguez from '../assets/caras/seleccion/Dominguez.jpg'
import Dybala from '../assets/caras/seleccion/Dybala.jpg'
import Foyth from '../assets/caras/seleccion/Foyth.jpg'
import Gomez from '../assets/caras/seleccion/Gomez.jpg'
import Lautaro from '../assets/caras/seleccion/Lautaro.jpg'
import LoCelso from '../assets/caras/seleccion/LoCelso.jpg'
import Emiliano from '../assets/caras/seleccion/Martinez.jpg'
import Messi from '../assets/caras/seleccion/Messi.jpg'
import Montiel from '../assets/caras/seleccion/Montiel.jpg'
import Ocampos from '../assets/caras/seleccion/Ocampos.jpg'
import Otamendi from '../assets/caras/seleccion/Otamendi.jpg'
import Palacios from '../assets/caras/seleccion/Palacios.jpg'
import Paredes from '../assets/caras/seleccion/Paredes.jpg'
import Pereyra from '../assets/caras/seleccion/Pereyra.jpg'
import Pezzella from '../assets/caras/seleccion/Pezzella.jpg'
import Quarta from '../assets/caras/seleccion/Quarta.jpg'
import Rodriguez from '../assets/caras/seleccion/Rodriguez.jpg'
import Saravia from '../assets/caras/seleccion/Saravia.jpg'
import Tagliafico from '../assets/caras/seleccion/Tagliafico.jpg'

import Alvarez from '../assets/caras/river/Alvarez.jpg';
import Angileri from '../assets/caras/river/Angileri.jpg';
import Bologna from '../assets/caras/river/Bologna.jpg';
import Borre from '../assets/caras/river/Borre.jpg';
import Carrascal from '../assets/caras/river/Carrascal.jpg';
import Casco from '../assets/caras/river/Casco.jpg';
import DeLaCruz from '../assets/caras/river/DeLaCruz.jpg';
import Diaz from '../assets/caras/river/Diaz.jpg';
import Enzo from '../assets/caras/river/Enzo.jpg';
import Girotti from '../assets/caras/river/Girotti.jpg';
import Maidana from '../assets/caras/river/Maidana.jpg';
import Martinez from '../assets/caras/river/Martinez.jpg';
import Palavecino from '../assets/caras/river/Palavecino.jpg';
import Paradela from '../assets/caras/river/Paradela.jpg';
import Ponzio from '../assets/caras/river/Ponzio.jpg';
import Rojas from '../assets/caras/river/Rojas.jpg';
import Suarez from '../assets/caras/river/Suarez.jpg';
import Vigo from '../assets/caras/river/Vigo.jpg';
import Zuculini from '../assets/caras/river/Zuculini.jpg';

import Buffarini from '../assets/caras/boca/Buffarini.jpg';
import Campuzano from '../assets/caras/boca/Campuzano.jpg';
import Capaldo from '../assets/caras/boca/Capaldo.jpg';
import Cardona from '../assets/caras/boca/Cardona.jpg';
import Fabra from '../assets/caras/boca/Fabra.jpg';
import Izquierdoz from '../assets/caras/boca/Izquierdoz.jpg';
import Lopez from '../assets/caras/boca/Lopez.jpg';
import Maroni from '../assets/caras/boca/Maroni.jpg';
import Mas from '../assets/caras/boca/Mas.jpg';
import Medina from '../assets/caras/boca/Medina.jpg';
import Obando from '../assets/caras/boca/Obando.jpg';
import Rojo from '../assets/caras/boca/Rojo.jpg';
import Rossi from '../assets/caras/boca/Rossi.jpg';
import Salvio from '../assets/caras/boca/Salvio.jpg';
import Soldano from '../assets/caras/boca/Soldano.jpg';
import Tevez from '../assets/caras/boca/Tevez.jpg';
import Varela from '../assets/caras/boca/Varela.jpg';
import Villa from '../assets/caras/boca/Villa.jpg';
import Zambrano from '../assets/caras/boca/Zambrano.jpg';
import Zarate from '../assets/caras/boca/Zarate.jpg';
import Zeballos from '../assets/caras/boca/Zeballos.jpg';

// JUGADORES

export const jugadoresSeleccion = [
    {
        nombre: 'Armani',
        imagen: Armani,
        id: 1,
        seleccionado: false 
    },
    {
        nombre: 'Andrada',
        imagen: Andrada,
        id: 2,
        seleccionado: false 
    },
    {
        nombre: 'E. Martinez',
        imagen: Emiliano,
        id: 3,
        seleccionado: false 
    },
    {
        nombre: 'Otamendi',
        imagen: Otamendi,
        id: 4,
        seleccionado: false 
    },
    {
        nombre: 'Montiel',
        imagen: Montiel,
        id: 5,
        seleccionado: false 
    },
    {
        nombre: 'Pezzella',
        imagen: Pezzella,
        id: 6,
        seleccionado: false 
    },
    {
        nombre: 'M. Quarta',
        imagen: Quarta,
        id: 7,
        seleccionado: false 
    },
    {
        nombre: 'Tagliafico',
        imagen: Tagliafico,
        id: 8,
        seleccionado: false 
    },
    {
        nombre: 'Foyth',
        imagen: Foyth,
        id: 9,
        seleccionado: false 
    },
    {
        nombre: 'Saravia',
        imagen: Saravia,
        id: 10,
        seleccionado: false 
    },
    {
        nombre: 'Paredes',
        imagen: Paredes,
        id: 11,
        seleccionado: false 
    },
    {
        nombre: 'Rodriguez',
        imagen: Rodriguez,
        id: 12,
        seleccionado: false 
    },
    {
        nombre: 'Dominguez',
        imagen: Dominguez,
        id: 13,
        seleccionado: false 
    },
    {
        nombre: 'Palacios',
        imagen: Palacios,
        id: 14,
        seleccionado: false 
    },
    {
        nombre: 'Pereyra',
        imagen: Pereyra,
        id: 15,
        seleccionado: false 
    },
    {
        nombre: 'De Paul',
        imagen: DePaul,
        id: 16,
        seleccionado: false 
    },
    {
        nombre: 'Lo Celso',
        imagen: LoCelso,
        id: 17,
        seleccionado: false 
    },
    {
        nombre: 'J. Correa',
        imagen: Correa,
        id: 18,
        seleccionado: false 
    },
    {
        nombre: 'Papu Gomez',
        imagen: Gomez,
        id: 19,
        seleccionado: false 
    },
    {
        nombre: 'Di Maria',
        imagen: DiMaria,
        id: 20,
        seleccionado: false 
    },
    {
        nombre: 'Messi',
        imagen: Messi,
        id: 21,
        seleccionado: false 
    },
    {
        nombre: 'Agüero',
        imagen: Aguero,
        id: 22,
        seleccionado: false 
    },
    {
        nombre: 'Lautaro',
        imagen: Lautaro,
        id: 23,
        seleccionado: false 
    },
    {
        nombre: 'Dybala',
        imagen: Dybala,
        id: 24,
        seleccionado: false 
    },
    {
        nombre: 'Ocampos',
        imagen: Ocampos,
        id: 25,
        seleccionado: false 
    },
];

export const jugadoresRiver = [
    {
        nombre: 'Armani',
        imagen: Armani,
        id: 1,
        seleccionado: false 
    },
    {
        nombre: 'Bologna',
        imagen: Bologna,
        id: 2,
        seleccionado: false 
    },
    {
        nombre: 'Diaz',
        imagen: Diaz,
        id: 3,
        seleccionado: false 
    },
    {
        nombre: 'Rojas',
        imagen: Rojas,
        id: 4,
        seleccionado: false 
    },
    {
        nombre: 'Casco',
        imagen: Casco,
        id: 5,
        seleccionado: false 
    },
    {
        nombre: 'Angileri',
        imagen: Angileri,
        id: 6,
        seleccionado: false 
    },
    {
        nombre: 'Vigo',
        imagen: Vigo,
        id: 7,
        seleccionado: false 
    },
    {
        nombre: 'Martinez',
        imagen: Martinez,
        id: 8,
        seleccionado: false 
    },
    {
        nombre: 'Maidana',
        imagen: Maidana,
        id: 9,
        seleccionado: false 
    },
    {
        nombre: 'Montiel',
        imagen: Montiel,
        id: 10,
        seleccionado: false 
    },
    {
        nombre: 'Zuculini',
        imagen: Zuculini,
        id: 11,
        seleccionado: false 
    },
    {
        nombre: 'Ponzio',
        imagen: Ponzio,
        id: 12,
        seleccionado: false 
    },
    {
        nombre: 'Enzo',
        imagen: Enzo,
        id: 13,
        seleccionado: false 
    },
    {
        nombre: 'Palavecino',
        imagen: Palavecino,
        id: 14,
        seleccionado: false 
    },
    {
        nombre: 'Paradela',
        imagen: Paradela,
        id: 15,
        seleccionado: false 
    },
    {
        nombre: 'De la Cruz',
        imagen: DeLaCruz,
        id: 16,
        seleccionado: false 
    },
    {
        nombre: 'Carrascal',
        imagen: Carrascal,
        id: 17,
        seleccionado: false 
    },
    {
        nombre: 'Suarez',
        imagen: Suarez,
        id: 18,
        seleccionado: false 
    },
    {
        nombre: 'Alvarez',
        imagen: Alvarez,
        id: 19,
        seleccionado: false 
    },
    {
        nombre: 'Girotti',
        imagen: Girotti,
        id: 20,
        seleccionado: false 
    },
    {
        nombre: 'Borre',
        imagen: Borre,
        id: 21,
        seleccionado: false 
    },
];

export const jugadoresBoca = [
    {
        nombre: 'Andrada',
        imagen: Andrada,
        id: 1,
        seleccionado: false 
    },
    {
        nombre: 'Rossi',
        imagen: Rossi,
        id: 2,
        seleccionado: false 
    },
    {
        nombre: 'Lopez',
        imagen: Lopez,
        id: 3,
        seleccionado: false 
    },
    {
        nombre: 'Izquierdoz',
        imagen: Izquierdoz,
        id: 4,
        seleccionado: false 
    },
    {
        nombre: 'Rojo',
        imagen: Rojo,
        id: 5,
        seleccionado: false 
    },
    {
        nombre: 'Zambrano',
        imagen: Zambrano,
        id: 6,
        seleccionado: false 
    },
    {
        nombre: 'Mas',
        imagen: Mas,
        id: 7,
        seleccionado: false 
    },
    {
        nombre: 'Buffarini',
        imagen: Buffarini,
        id: 8,
        seleccionado: false 
    },
    {
        nombre: 'Capaldo',
        imagen: Capaldo,
        id: 9,
        seleccionado: false 
    },
    {
        nombre: 'Fabra',
        imagen: Fabra,
        id: 10,
        seleccionado: false 
    },
    {
        nombre: 'Campuzano',
        imagen: Campuzano,
        id: 11,
        seleccionado: false 
    },
    {
        nombre: 'Obando',
        imagen: Obando,
        id: 12,
        seleccionado: false 
    },
    {
        nombre: 'Medina',
        imagen: Medina,
        id: 13,
        seleccionado: false 
    },
    {
        nombre: 'Maroni',
        imagen: Maroni,
        id: 14,
        seleccionado: false 
    },
    {
        nombre: 'Zeballos',
        imagen: Zeballos,
        id: 16,
        seleccionado: false 
    },
    {
        nombre: 'Varela',
        imagen: Varela,
        id: 17,
        seleccionado: false 
    },
    {
        nombre: 'Cardona',
        imagen: Cardona,
        id: 18,
        seleccionado: false 
    },
    {
        nombre: 'Tevez',
        imagen: Tevez,
        id: 19,
        seleccionado: false 
    },
    {
        nombre: 'Salvio',
        imagen: Salvio,
        id: 20,
        seleccionado: false 
    },
    {
        nombre: 'Zarate',
        imagen: Zarate,
        id: 21,
        seleccionado: false 
    },
    {
        nombre: 'Villa',
        imagen: Villa,
        id: 22,
        seleccionado: false 
    },
    {
        nombre: 'Soldano',
        imagen: Soldano,
        id: 23,
        seleccionado: false 
    }
];